import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useLocation, useParams } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { blogData } from "../../model/BlogData";
import { getBlogsByName } from "../../services/BlogService";
import { Utility } from "../../utility/Utility";

const BlogPage = () => {
    const [blogs, setBlogs] = React.useState<blogData[]>();
    const path = useLocation();
    // const blogName = path.pathname.substring(path.pathname.lastIndexOf('/')+1)
    const { '*': blogName} = useParams()

    useEffect(() => {
        getBlogsByName(blogName || "")
            .then(x => { setBlogs(x) });
    }, [blogName]);

    return <>
        {blogs && blogs.length == 0 && <Typography component="div" color="red" sx={{ fontSize: 30, textAlign: "center", fontWeight: 600 }}>404 Content not available</Typography>}
        {blogs && blogs.length > 0 && <Box sx={{
            position: "relative",
            width: "100%",
            overflow: "auto",
        }}>
            <div dangerouslySetInnerHTML={{ __html: blogs[0].content }}>
            </div>

        </Box>
        }
    </>;
}

export default BlogPage;